import { cx } from "../../lib/cx";
import { dsCard } from "./styles";

export type CounterTile = {
  id: string;
  value: string;
  label: string;
  /** Overdue numbers use coral. Anything else stays ink. */
  tone?: "coral" | "default";
};

type Props = {
  title?: string;
  meta?: string;
  tiles: CounterTile[];
};

/** Equal inner tiles on a glass card. Number 22px / 600, label 11.5px. */
export function CounterTiles({ title, meta, tiles }: Props) {
  return (
    <section data-ds="" data-testid="ds-counters" className={cx(dsCard, "flex h-full flex-col")}>
      {title || meta ? (
        <header className="mb-ds-head flex shrink-0 items-baseline justify-between gap-2.5">
          {title ? (
            <h2 className="m-0 font-ds text-ds-card font-semibold text-ds-ink">{title}</h2>
          ) : (
            <span />
          )}
          {meta ? <span className="text-ds-meta font-normal text-ds-ink-3">{meta}</span> : null}
        </header>
      ) : null}
      <div className="grid shrink-0 grid-cols-3 gap-3">
        {tiles.map((tile) => (
          <div
            key={tile.id}
            data-testid={`ds-counter-${tile.id}`}
            className="rounded-ds-tile bg-ds-glass-strong px-3 py-2.5 shadow-none"
          >
            <b
              className={cx(
                "block text-ds-kpi font-semibold text-ds-ink",
                tile.tone === "coral" && "text-ds-coral",
              )}
            >
              {tile.value}
            </b>
            <span className="text-ds-label font-normal text-ds-ink-3">{tile.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
